import React from 'react';

import icon from '../../../images/notification-rejected-offers.svg';

import { FOHImage } from '../../ingredients';

export interface FOHNotificationRejectedOffersProps {}

export const FOHNotificationRejectedOffers = (
  props: FOHNotificationRejectedOffersProps
) => (
  <FOHImage
    {...props}
    source={{ uri: icon }}
    style={{ width: 24, height: 24 }}
    {...props}
  />
);
